import { EffectsModule } from '@ngrx/effects';
import { CardsEffects } from './+state/cards.effects';
import { CardsNgrxFacade } from './cards.facade';
import { CardsService } from './services/cards.service';
import { StoreModule } from '@ngrx/store';
import * as fromCards from './+state/cards.reducer';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(fromCards.CARDS_FEATURE_KEY, fromCards.cardsReducer),
        EffectsModule.forFeature([CardsEffects])
    ],
    providers: [CardsService, CardsNgrxFacade, CardsEffects]
})
export class CardsNgrxModule {}
